if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.productDataPromise = null;
        this.ensureQuickAddTitleStyles();

        this.modalContent.addEventListener(
          'click',
          (event) => {
            const buyNowButton = event.target.closest?.('.quick-add-buy-now');
            if (!buyNowButton) return;

            event.preventDefault();
            event.stopPropagation();
            this.addToCartAndRedirect(buyNowButton);
          },
          true
        );

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      ensureQuickAddTitleStyles() {
        if (document.getElementById('quick-add-small-title-styles')) return;

        const style = document.createElement('style');
        style.id = 'quick-add-small-title-styles';
        style.textContent = `
          quick-add-modal .product__title,
          quick-add-modal .product__title h1,
          quick-add-modal .product__title h2,
          quick-add-modal .product__title a {
            font-size: 20px !important;
            line-height: 1.25 !important;
          }

          quick-add-modal .product__title svg,
          quick-add-modal .product__title .icon {
            width: 14px !important;
            height: 14px !important;
            min-width: 14px !important;
          }

          quick-add-modal .payment-icons,
          quick-add-modal .list-payment {
            gap: 3px !important;
          }

          quick-add-modal .payment-icon,
          quick-add-modal .list-payment__item {
            width: auto !important;
            min-width: 0 !important;
            padding: 1px !important;
          }

          quick-add-modal .payment-icon > svg,
          quick-add-modal .payment-icons svg,
          quick-add-modal .list-payment__item svg,
          quick-add-modal .product__payment-icons svg,
          quick-add-modal .product__payment-icon svg {
            width: 34px !important;
            height: auto !important;
            max-width: 34px !important;
            max-height: 20px !important;
          }

          @media screen and (max-width: 749px) {
            quick-add-modal .product__title,
            quick-add-modal .product__title h1,
            quick-add-modal .product__title h2,
            quick-add-modal .product__title a {
              font-size: 17px !important;
            }

            quick-add-modal .product__title svg,
            quick-add-modal .product__title .icon {
              width: 12px !important;
              height: 12px !important;
              min-width: 12px !important;
            }

            quick-add-modal .payment-icon > svg,
            quick-add-modal .payment-icons svg,
            quick-add-modal .list-payment__item svg,
            quick-add-modal .product__payment-icons svg,
            quick-add-modal .product__payment-icon svg {
              width: 28px !important;
              height: auto !important;
              max-width: 28px !important;
              max-height: 18px !important;
            }
          }
        `;

        document.head.appendChild(style);
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification) {
          cartNotification.setActiveElement(this.openedBy);
        }

        this.modalContent.innerHTML = '';
        this.productDataPromise = null;

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');

        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const productUrl = opener.getAttribute('data-product-url');

        this.productDataPromise = this.loadProductData(productUrl).catch(
          (error) => {
            console.error('Quick Add product JSON error:', error);
            return null;
          }
        );

        fetch(productUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error: ${response.status}`);
            }
            return response.text();
          })
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            const productElement = responseHTML.querySelector('product-info');

            if (!productElement) {
              throw new Error('Product information was not found');
            }

            this.preprocessHTML(productElement);
            this.insertOffers(productElement);
            this.removeProductDescription(productElement);
            this.replaceBuyNowButton(productElement);

            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML
            );

            this.resizePaymentIcons();
            window.setTimeout(() => this.resizePaymentIcons(), 100);
            window.setTimeout(() => this.resizePaymentIcons(), 300);

            this.setupBuyNowValidation();

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            super.show(opener);
          })
          .catch((error) => {
            console.error('Error loading product modal:', error);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      resizePaymentIcons() {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const width = isMobile ? '52px' : '70px';
        const maxHeight = isMobile ? '100px' : '100px';

        this.modalContent
          .querySelectorAll(
            '.payment-methods .payment-icons .payment-icon > svg, ' +
              '.list-payment__item svg, ' +
              '.product__payment-icons svg, ' +
              '.product__payment-icon svg'
          )
          .forEach((svg) => {
            svg.style.setProperty('width', width, 'important');
            svg.style.setProperty('height', 'auto', 'important');
            svg.style.setProperty('max-width', width, 'important');
            svg.style.setProperty('max-height', maxHeight, 'important');
          });
      }

      insertOffers(productElement) {
        const submitButton = productElement.querySelector(
          '[id^="ProductSubmitButton-"]'
        );
        const submitButtonId = submitButton ? submitButton.id : '';

        const offersHTML = `
          <div
            id="offers-list-container-quick-add"
            data-cart-button-id="${submitButtonId}"
            style="margin-top: 0px;"
          >
            <div class="pb-82b0">
              <div class="pb-d9ff">
                <span
                  class="pb-200e"
                  style="background-color: rgb(48, 48, 48); height: 4px;"
                ></span>
                <p
                  class="pb-c167"
                  style="color: rgb(48, 48, 48); font-size: 16px;"
                >
                  Compra más y ahorra
                </p>
                <span
                  class="pb-200e"
                  style="background-color: rgb(48, 48, 48); height: 4px;"
                ></span>
              </div>

              <div>
                ${this.getOfferItemHTML('COMPRA 3+', '¡Rebajas! -10%')}
                ${this.getOfferItemHTML('COMPRA 6+', '¡Rebajas! -15%')}
                ${this.getOfferItemHTML('COMPRA 10+', '¡Rebajas! -20%')}
                ${this.getOfferItemHTML('COMPRA 50+', '¡Rebajas! -50%')}
              </div>
            </div>
          </div>
        `;

        const tempWrapper = document.createElement('div');
        tempWrapper.innerHTML = offersHTML.trim();
        const offersElement = tempWrapper.firstElementChild;
        if (!offersElement) return;

        const descriptionContainer = productElement.querySelector(
          '.product__description-container'
        );

        if (descriptionContainer) {
          descriptionContainer.insertAdjacentElement(
            'beforebegin',
            offersElement
          );
          return;
        }

        const productInfoContainer = productElement.querySelector(
          '.product__info-container'
        );

        if (productInfoContainer) {
          productInfoContainer.appendChild(offersElement);
        } else {
          productElement.appendChild(offersElement);
        }
      }

      getOfferItemHTML(quantityText, discountText) {
        return `
          <div
            class="pb-8d58 custom-offer-item"
            style="
              border-radius: 12px;
              background-color: rgb(255, 255, 255);
              border: 1px solid rgb(255, 95, 0);
            "
          >
            <div class="pb-b527" style="padding: 12px 10px;">
              <div></div>
              <div class="pb-acdf">
                <div class="pb-9603">
                  <p
                    class="pb-3f45"
                    style="font-size: 10px; color: rgb(0, 0, 0);"
                  >
                    ${quantityText}
                  </p>
                  <p
                    class="pb-2e6c"
                    style="color: rgb(255, 95, 0); font-size: 9px;"
                  ></p>
                </div>
                <div class="pb-d440" style="color: black;">
                  <p
                    class="pb-081e"
                    style="color: rgba(139, 5, 61, 0.76); font-size: 10px;"
                  >
                    ${discountText}
                  </p>
                </div>
              </div>
            </div>
          </div>
        `;
      }

      removeProductDescription(productElement) {
        productElement
          .querySelectorAll(
            '.product__description-container, .product__description'
          )
          .forEach((element) => element.remove());

        productElement
          .querySelectorAll('.product__text, .inline-richtext')
          .forEach((element) => {
            const text = this.normalizeText(element.textContent);
            if (text === 'descripcion' || text === 'description') {
              element.remove();
            }
          });
      }

      replaceBuyNowButton(productElement) {
        productElement
          .querySelectorAll('.shopify-payment-button')
          .forEach((paymentContainer) => {
            paymentContainer.classList.remove('shopify-payment-button');
            paymentContainer.classList.add('quick-add-buy-now-container');
            paymentContainer.style.width = '100%';

            const buyNowButton = document.createElement('button');
            buyNowButton.type = 'button';
            buyNowButton.className =
              'shopify-payment-button__button ' +
              'shopify-payment-button__button--unbranded ' +
              'quick-add-buy-now disabled button--disabled';
            buyNowButton.textContent = 'Compra ahora';
            buyNowButton.disabled = true;
            buyNowButton.setAttribute('aria-disabled', 'true');
            buyNowButton.style.width = '100%';
            buyNowButton.style.opacity = '0.55';
            buyNowButton.style.cursor = 'not-allowed';

            paymentContainer.replaceChildren(buyNowButton);
          });
      }

      normalizeText(value) {
        return String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim()
          .toLowerCase();
      }

      isPlaceholderOption(option) {
        if (!option) return true;

        const value = this.normalizeText(option.value);
        const text = this.normalizeText(option.textContent);
        const placeholders = [
          '',
          'sabor',
          'sabor...',
          'sabores',
          'selecciona un sabor',
          'seleccione un sabor',
          'elige un sabor',
        ];

        return (
          option.disabled ||
          placeholders.includes(value) ||
          placeholders.includes(text)
        );
      }

      getFlavorSelect(scope) {
        const preferredSelect = scope.querySelector(
          '.product-variant-select-for-disable'
        );
        if (preferredSelect) return preferredSelect;

        return Array.from(scope.querySelectorAll('select')).find((select) => {
          const identity = this.normalizeText(
            `${select.name || ''} ${select.id || ''} ${
              select.getAttribute('aria-label') || ''
            }`
          );

          return (
            identity.includes('sabor') ||
            identity.includes('flavor') ||
            Array.from(select.options).some((option) => {
              const optionText = this.normalizeText(option.textContent);
              return optionText === 'sabor' || optionText === 'sabor...';
            })
          );
        });
      }

      syncBuyNowState() {
        const productInfo = this.modalContent.querySelector('product-info');
        const buyNowButton = this.modalContent.querySelector(
          '.quick-add-buy-now'
        );

        if (!productInfo || !buyNowButton) return false;

        const flavorSelect = this.getFlavorSelect(productInfo);
        const selectedOption = flavorSelect
          ? flavorSelect.options[flavorSelect.selectedIndex]
          : null;
        const placeholderSelected = flavorSelect
          ? this.isPlaceholderOption(selectedOption)
          : false;

        const form = this.getProductForm(productInfo);
        const variantInput = form?.querySelector('[name="id"]');
        const variantMissing =
          !variantInput ||
          (!flavorSelect &&
            (!variantInput.value || variantInput.disabled));

        const shouldDisable = placeholderSelected || variantMissing;

        buyNowButton.disabled = shouldDisable;
        buyNowButton.classList.toggle('disabled', shouldDisable);
        buyNowButton.classList.toggle('button--disabled', shouldDisable);
        buyNowButton.setAttribute('aria-disabled', String(shouldDisable));
        buyNowButton.style.opacity = shouldDisable ? '0.55' : '1';
        buyNowButton.style.cursor = shouldDisable
          ? 'not-allowed'
          : 'pointer';

        return !shouldDisable;
      }

      setupBuyNowValidation() {
        const productInfo = this.modalContent.querySelector('product-info');
        if (!productInfo) return;

        const refreshButtonState = () => {
          window.requestAnimationFrame(() => this.syncBuyNowState());
          window.setTimeout(() => this.syncBuyNowState(), 100);
          window.setTimeout(() => this.syncBuyNowState(), 300);
        };

        productInfo.addEventListener('input', refreshButtonState);
        productInfo.addEventListener('change', refreshButtonState);
        productInfo.addEventListener('variant:change', refreshButtonState);
        productInfo.addEventListener('variant-change', refreshButtonState);

        refreshButtonState();
      }

      getProductForm(productInfo) {
        return productInfo?.querySelector(
          'product-form form[action*="/cart/add"], form[action*="/cart/add"]'
        );
      }

      getProductJsonUrl(productUrl) {
        const url = new URL(productUrl, window.location.origin);
        url.search = '';
        url.hash = '';
        url.pathname = url.pathname.replace(/\/$/, '');
        if (!url.pathname.endsWith('.js')) url.pathname += '.js';
        return url.toString();
      }

      async loadProductData(productUrl) {
        const response = await fetch(this.getProductJsonUrl(productUrl), {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) {
          throw new Error(`Product JSON HTTP error: ${response.status}`);
        }

        return response.json();
      }

      getSelectedProductOptions(productInfo) {
        const controls = Array.from(
          productInfo.querySelectorAll('[name^="options["]')
        );
        const optionNames = [];

        controls.forEach((control) => {
          if (control.name && !optionNames.includes(control.name)) {
            optionNames.push(control.name);
          }
        });

        return optionNames.map((name) => {
          const group = controls.filter((control) => control.name === name);
          const select = group.find((control) => control.tagName === 'SELECT');
          if (select) return select.value;

          const checked = group.find((control) => control.checked);
          return checked ? checked.value : '';
        });
      }

      async resolveSelectedVariantId(productInfo) {
        const selectedOptions = this.getSelectedProductOptions(productInfo);
        const form = this.getProductForm(productInfo);
        const currentVariantId = form
          ?.querySelector('[name="id"]')
          ?.value?.trim();

        if (!selectedOptions.length) {
          if (currentVariantId) return currentVariantId;
          throw new Error('No se pudo confirmar la variante.');
        }

        const productData = await this.productDataPromise;
        const variants = productData?.variants || productData?.product?.variants;

        if (!Array.isArray(variants)) {
          throw new Error(
            'No se pudo confirmar el sabor. Inténtalo de nuevo.'
          );
        }

        const selectedVariant = variants.find((variant) => {
          if (!Array.isArray(variant.options)) return false;

          return selectedOptions.every(
            (value, index) =>
              this.normalizeText(variant.options[index]) ===
              this.normalizeText(value)
          );
        });

        if (!selectedVariant?.id) {
          throw new Error(
            'No se pudo confirmar el sabor. Inténtalo de nuevo.'
          );
        }

        if (selectedVariant.available === false) {
          throw new Error('Este sabor no está disponible.');
        }

        return String(selectedVariant.id);
      }

      async addToCartAndRedirect(button) {
        const productInfo = button.closest('product-info');
        const form = this.getProductForm(productInfo);

        if (!form) {
          console.error('Quick Add product form was not found');
          return;
        }

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        if (!this.syncBuyNowState()) {
          window.alert('Selecciona un sabor antes de continuar.');
          return;
        }

        const originalText = button.textContent;
        button.disabled = true;
        button.classList.add('loading');
        button.textContent = 'Añadiendo...';

        try {
          const selectedVariantId = await this.resolveSelectedVariantId(
            productInfo
          );
          const activeForm = this.getProductForm(productInfo) || form;
          const formData = new FormData(activeForm);

          formData.set('id', selectedVariantId);
          formData.delete('sections');
          formData.delete('sections_url');

          const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const result = await response.json().catch(() => ({}));

          if (!response.ok) {
            throw new Error(
              result.description ||
                result.message ||
                'No se pudo añadir el producto al carrito.'
            );
          }

          const shopRoot = window.Shopify?.routes?.root || '/';
          const cartUrl = window.routes?.cart_url || `${shopRoot}cart`;
          window.location.assign(cartUrl);
        } catch (error) {
          console.error('Quick Add cart error:', error);
          window.alert(
            error.message || 'No se pudo añadir el producto al carrito.'
          );

          button.classList.remove('loading');
          button.textContent = originalText;
          this.syncBuyNowState();
        }
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (
            classApplied.startsWith('color-') ||
            classApplied === 'gradient'
          ) {
            this.modalContent.classList.add(classApplied);
          }
        });

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector(
          'pickup-availability'
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        productElement
          .querySelectorAll('modal-dialog')
          .forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        if (!sectionId) return;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML = productElement.innerHTML.replaceAll(
          oldId,
          newId
        );

        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(
              attribute.name,
              attribute.value.replaceAll(oldId, newId)
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((item) => item.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, ' +
          '(min-width: 750px) calc((100vw - 11.5rem) / 2), ' +
          'calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((image) => {
          image.setAttribute('sizes', mediaImageSizes);
        });
      }
    }
  );
}